import { NavItem } from "../../../components/nav/item";
import { NavSubItem } from "../../../components/nav/sub-item";
import { DATABASE } from "icons";
import { usePermissions } from "contexts/permission";

export function MasterDataNavigations() {
  const permissions = usePermissions();

  return (
    <NavItem
      title="Master Data"
      icon={DATABASE}
      url="/master-data"
      matchExact={true}
    >
      <NavSubItem
        title="Departments"
        url="/master-data/departments"
        requiredPermissions={{
          collection: "departments",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Holiday"
        url="/master-data/holidays"
        requiredPermissions={{
          collection: "holidays",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Currencies"
        url="/master-data/currencies"
        requiredPermissions={{
          collection: "currencies",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Countries"
        url="/master-data/countries"
        requiredPermissions={{
          collection: "countries",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Job Titles"
        url="/master-data/job-titles"
        requiredPermissions={{
          collection: "job_titles",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Grades"
        url="/master-data/grades"
        requiredPermissions={{
          collection: "grades",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Skills"
        url="/master-data/skills"
        requiredPermissions={{
          collection: "skills",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Functions"
        url="/master-data/functions"
        requiredPermissions={{
          collection: "functions",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Cost Master"
        url="/master-data/cost-master"
        requiredPermissions={{
          collection: "cost_master",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Tags"
        url="/master-data/tags"
        requiredPermissions={{
          collection: "tags",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Survey Categories"
        url="/master-data/categories"
        requiredPermissions={{
          collection: "survey_categories",
          action: "read",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Survey Questions"
        url="/master-data/category-questions"
        requiredPermissions={{
          collection: "survey_questions",
          action: "read",
          type: "collection",
        }}
      />
    </NavItem>
  );
}
